import Cookies from "js-cookie"

const TC_SESSION_ACTIVE_COOKIE = "tc_session_active"

export const hasActiveSession = () => !!Cookies.get(TC_SESSION_ACTIVE_COOKIE)
